import classNames from "classnames";

// background-color: rgba(0, 0, 0, 0) !important;
// 	color: red !important;
// 	border: 2px solid red !important;

export function SeshWarningButton(
	props: React.HTMLProps<HTMLButtonElement> & { is_loading?: boolean }
) {
	const { is_loading, ...base_props } = props;

	return (
		<button
			{...base_props}
			className={classNames(
				props.className,
				"h-10 w-full border-2 border-warning bg-transparent px-2 font-bold text-warning hover:bg-warning hover:text-black",
				{
					"button is-loading": is_loading,
				}
			)}
			type={
				(base_props.type ?? "button") as "button" | "submit" | "reset"
			}
		></button>
	);
}
